import { createContext, useContext } from 'react';
import { StoreApi, useStore } from 'zustand';
import { AdminCatalogueConfiguration, CompanyCatalogueConfiguration, PartnerCatalogueConfiguration } from './catalogue';

export interface CatalogueInfo {
  configuration: CompanyCatalogueConfiguration | PartnerCatalogueConfiguration | AdminCatalogueConfiguration;
  filterPackId?: string;
  showLatest: boolean;
  setShowLatest: (showLatest: boolean) => void;
  inPurchaseOrder: boolean;
}

export interface CatalogueActions {}

export type CatalogueService = CatalogueActions & CatalogueInfo;

export const CatalogueContext = createContext<StoreApi<CatalogueService> | null>(null);

export function useCatalogueService<U>(selector: (store: CatalogueInfo) => U): U {
  const context = useContext(CatalogueContext);
  if (!context) {
    throw new Error('useCatalogueService must be used within a CatalogueProvider');
  }
  return useStore(context, selector);
}
